/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Engagement_Form_TitleInputs */

const en_us2_engagement_form_title = /** @type {(inputs: Engagement_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What could we do better?`)
};

const pt_br2_engagement_form_title = /** @type {(inputs: Engagement_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que podemos melhorar?`)
};

const es_419_engagement_form_title = /** @type {(inputs: Engagement_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué podemos mejorar?`)
};

const pt_pt2_engagement_form_title = /** @type {(inputs: Engagement_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que podemos melhorar?`)
};

const fr_fr2_engagement_form_title = /** @type {(inputs: Engagement_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce qu'on pourrait améliorer ?`)
};

const de_de2_engagement_form_title = /** @type {(inputs: Engagement_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was könnten wir besser machen?`)
};

const it_it2_engagement_form_title = /** @type {(inputs: Engagement_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa possiamo migliorare?`)
};

/**
* | output |
* | --- |
* | "What could we do better?" |
*
* @param {Engagement_Form_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_form_title = /** @type {((inputs?: Engagement_Form_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_Form_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_form_title(inputs)
	if (locale === "es-419") return es_419_engagement_form_title(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_form_title(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_form_title(inputs)
	if (locale === "de-DE") return de_de2_engagement_form_title(inputs)
	if (locale === "it-IT") return it_it2_engagement_form_title(inputs)
	return en_us2_engagement_form_title(inputs)
});
export { engagement_form_title as "engagement.form_title" }